import React from "react";

import { IconButton } from "@mui/material";
import { useOperationDespatchContext } from "../../../../contexts/DespatchContext";
import { CloseCircle as IconCloseCircle } from "iconsax-react";

export const DiaryHeaderFullscreenCloseButton = () => {
  const { isFullscreen, toogleFullscreen } = useOperationDespatchContext();

  if (!isFullscreen) return null;

  return (
    <IconButton
      onClick={toogleFullscreen}
      size="large"
      color="inherit"
      style={{ marginLeft: "auto" }}
    >
      <IconCloseCircle size={20} />
    </IconButton>
  );
};
